var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isToastEnable)?_c('div',{staticClass:"toast-msg",class:_vm.type},[(_vm.isClosed)?_c('span',{staticClass:"close",on:{"click":function($event){return _vm.close()}}},[_vm._v("X")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),_vm._t("msgbtn")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }